





























































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import ListViewItem from "list-view/src/listviewitem";

import DefaultModel from "@views/a-model/default-model";
import EnumNewsType from "../../dataSource/api/RunPay/DataModels/Enums/EnumNewsType";
import ControlValidatorGroupComponent from "../components/control-validator-group.vue";

import ImagePreviewModel from "crop-image/src/ImagePreviewModel";
import ObjectFabric from "../components/objectFabric";
import SaveNewsTranslation from "../../dataSource/api/RunPay/Admin/IServices/Models/SaveNewsTranslation";
import SeoItemResponse from "@dataSource/api/RunPay/Admin/IServices/Models/Seo/SeoItemResponse";
import SeoTranslation from "@dataSource/api/RunPay/Admin/IServices/Models/Seo/SeoTranslation";

@Component({
  name: "seo",
  components: {}
})
export default class SeoComponent extends Vue {
  langArr = ["en", "ar", "fr", "ru"];
  defaultLang = "fr";
  // langArr = [ 'ro', 'ru'];
  // defaultLang = 'ro';

  innerItems: SeoItemResponse[] = [];

  pageSize = 13;
  currentPage = 1;
  totalItems = 0;

  modalWindowTitle = "";
  modalWindowShow = false;
  currentOperation = "add";
  currentEditItemId = 0;

  addingNews: SeoItemResponse = new SeoItemResponse();

  search = "";

  newsCategories = Array<ListViewItem<DefaultModel>>();
  isLoading = false;
  isLoadingModal = false;

  created() {
    document.title = this.$route.meta.title;
    const appsettings = require("../../../appsettings.json");
    const ProjectOptions = appsettings.ProjectOptions;
    this.langArr = ProjectOptions.langArr;
    this.defaultLang = ProjectOptions.defaultLang;
    // this.getNewsCategory();
    this.getNews({ Take: this.pageSize, Skip: 0 });
  }

  isValid(): boolean {
    return (this.$refs.validator as ControlValidatorGroupComponent).isValid();
  }

  // getNewsCategory() {
  //   for (let index = 0; index < 22; index++) {
  //     this.newsCategories.push(
  //       new ListViewItem(
  //         new DefaultModel(index, this.getNewsTypeName(index)),
  //         index == 0,
  //         false
  //       )
  //     );
  //   }
  // }
  // onChangePageName(value: ListViewItem<DefaultModel>[]) {
  //   this.newsCategories.forEach(
  //     item => (item.Selected = item.Value.id == value[0].Value.id)
  //   );
  // }

  getNews({ Skip, Take }: { Skip: number; Take: number }) {
    this.$api.SeoService.GetListEvent.once(response => {
      this.isLoading = false;
      if (!response.IsSuccess) {
        this.$notification.error(
          response.ErrorMessage.toString().substring(0, 200)
        );
        return;
      }

      this.totalItems = response.Value.Count;
      this.innerItems = response.Value.Items;
    });

    this.isLoading = true;
    this.$api.SeoService.GetList({
      Search: this.search,
      Skip: Skip,
      Take: this.pageSize
    });
  }

  getDefaultLangField(val: Array<SeoTranslation>, field: string): string {
    const currentLang = this.$locale.currentLang;
    let name =
      val.find(el => el.LangCode == currentLang) ||
      val.find(el => el.LangCode == this.defaultLang) ||
      val[0];
    if (field == "Title") return name.Title;
    else return name.Description;
  }

  onSearch() {
    this.getNews({ Take: this.pageSize, Skip: 0 });
  }

  onPaginationChanged(request: { Page: number; CountOnPage: number }) {
    this.currentPage = request.Page;
    this.getNews({
      Skip: (request.Page - 1) * request.CountOnPage,
      Take: request.CountOnPage
    });
  }

  onNewsAdd() {
    this.modalWindowTitle = this.$locale.getTranslate("Добавить СЕО текст");
    this.currentOperation = "add";
    this.addingNews = new SeoItemResponse();

    this.addingNews.Translations = new Array<SeoTranslation>();
    this.langArr.forEach(i => {
      this.addingNews.Translations.push({
        LangCode: i,
        Title: "",
        Description: ""
      });
    });
    this.modalWindowShow = true;
  }

  onNewsEdit(id: number) {
    this.modalWindowTitle = this.$locale.getTranslate("Редактировать");
    this.currentOperation = "edit";
    this.currentEditItemId = id;
    var itemNews = this.innerItems.filter(item => item.Id == id)[0];

    this.addingNews.PageUrl = itemNews.PageUrl;
    this.addingNews = itemNews;
    this.modalWindowShow = true;
  }

  closeModalWindow() {
    this.modalWindowShow = false;
  }

  /**
   * Сортировка таблицы по имени полю и направлению(0,1)
   */
  onSort(sortName: string, sortType: string) {
    // console.log("sortName",sortName," sortType:",sortType)
    switch (sortName) {
      case "id":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.id > b.id ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.id < b.id ? 1 : -1;
          });
          break;
        }
      case "name":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.name < b.name ? 1 : -1;
          });
          break;
        }
      case "category":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.type > b.type ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.type < b.type ? 1 : -1;
          });
          break;
        }
      case "dateAdd":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.dateCreate > b.dateCreate ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.dateCreate < b.dateCreate ? 1 : -1;
          });
          break;
        }
      default:
        break;
    }
  }

  loading() {
    this.isLoading = true;
    this.innerItems = [];
  }

  async onDelete(newsId: string) {
    await this.$dialog
      .confirm(this.$locale.getTranslate("Dialog_reallyDelete"))
      .then((res: boolean) => {
        this.isLoading = false;
        if (res) {
          this.$api.SeoService.DeleteEvent.once(response => {
            if (!response.IsSuccess) {
              this.$notification.error(response.ErrorMessage.toString());
              return;
            }
            this.getNews({ Take: this.pageSize, Skip: 0 });
          });
          this.loading();
          this.$api.SeoService.Delete(parseInt(newsId));
        }
      });
  }

  onOperation() {
    if (!this.isValid()) {
      this.$notification.error(
        this.$locale.getTranslate("Error filling in fields"),
        this.$locale.getTranslate("Erreur")
      );
      return;
    }

    this.$api.SeoService.SaveEvent.once(response => {
      this.isLoadingModal = false;

      if (!response.IsSuccess) {
        this.$notification.error(response.ErrorMessage.toString());
        return;
      }
      this.closeModalWindow();
      this.innerItems = [];
      this.getNews({ Take: this.pageSize, Skip: 0 });
    });

    this.isLoadingModal = true;
    let trans: SeoTranslation[] = [];
    this.addingNews.Translations.forEach(element => {
      trans.push(
        new SaveNewsTranslation({
          LangCode: element.LangCode.toString(),
          Name: element.Title.toString(),
          Description: element.Description.toString()
        })
      );
    });

    this.$api.SeoService.Save({
      Id: this.addingNews.Id,
      Translations: this.addingNews.Translations,
      PageUrl: this.addingNews.PageUrl
    });
    // console.log("NewsService.Save после")
  }

  getCurrentCategory(): DefaultModel {
    const category = this.newsCategories.filter(el => el.Selected);
    return category.length > 0 ? (category[0].Value as DefaultModel) : null;
  }

  getNewsType(typeId: number): EnumNewsType {
    switch (typeId) {
      case 0:
        return EnumNewsType.Top;

      case 1:
        return EnumNewsType.Blog;

      case 2:
        return EnumNewsType.Pressa;

      default:
        break;
    }
  }

  getNewsTypeName(typeId: number): string {
    switch (typeId) {
      case 0:
        return "index";
      case 1:
        return "userIndex";
      case 2:
        return "userWalletReplenishment";
      case 3:
        return "userPaymentForGoods";
      case 4:
        return "userWithdrawalOfFunds";
      case 5:
        return "userLimitsAndTariffs";
      case 6:
        return "businessInstallTerminal";
      case 7:
        return "businessAgentConnection";
      case 8:
        return "businessAdvertising";
      case 9:
        return "businessToCreditOrganizations";
      case 10:
        return "businessServiceProviders";
      case 11:
        return "businessRunpayQr";
      case 12:
        return "businessMakingPayments";
      case 13:
        return "businessServiceRepairs";
      case 14:
        return "aboutIndex";
      case 15:
        return "aboutFaq";
      case 16:
        return "aboutVacancies";
      case 17:
        return "aboutLicense";
      case 18:
        return "aboutPayingAgent";
      case 19:
        return "aboutAgreement";
      case 20:
        return "aboutContacts";
      case 21:
        return "newsIndex";
      default:
        break;
    }
  }

  onScroll(event: WheelEvent) {
    const target = this.$refs.scrollContainer as HTMLElement;
    const start = target.offsetTop;
    const childs = target.children;
    const currentScroll = target.scrollTop + event.deltaY;
    let currIndex = 0;
    for (currIndex = 0; currIndex < childs.length; currIndex++) {
      const el = childs[currIndex] as HTMLElement;
      const elStart = el.offsetTop - start;
      if (
        elStart <= currentScroll &&
        elStart + el.clientHeight >= currentScroll
      ) {
        break;
      }
    }
    const nextIndex = event.deltaY > 0 ? currIndex + 1 : currIndex;
    if (nextIndex < 0 || nextIndex >= childs.length) {
      return;
    }
    const nextEl = childs[nextIndex] as HTMLElement;
    target.scrollTop = nextEl.offsetTop - target.offsetTop;
    // this.scrollTo(target, nextEl.offsetTop - target.offsetTop);
    event.preventDefault();
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/pages/page-seo.vue